/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Not_FoundInputs */

const en_admin_registration_not_found = /** @type {(inputs: Admin_Registration_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registration not found`)
};

const de_admin_registration_not_found = /** @type {(inputs: Admin_Registration_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung nicht gefunden`)
};

/**
* | output |
* | --- |
* | "Registration not found" |
*
* @param {Admin_Registration_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_not_found = /** @type {((inputs?: Admin_Registration_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_not_found(inputs)
	return en_admin_registration_not_found(inputs)
});